module.exports = __webpack_public_path__ + "static/media/cladding-spraying-001.049529b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gallery/cladding-spraying-001.jpg
// module id = 97
// module chunks = 0